import React from 'react';
import EllipsesControl from '../../EllipsesControl/EllipsesControl';

export default function ShareActivityEllipsisHeaderComponent({label}) {
	return (
			<EllipsesControl noOfLines={1} content={label} tooltip={label} />
	);
}